import {
	Create,
	NumberInput,
	SelectInput,
	SimpleForm,
	TextInput,
} from "react-admin";

export const PartnerPayoutCreate = () => (
	<Create>
		<SimpleForm>
			<TextInput source="partnerId" label="Partner ID" required />
			<TextInput source="appId" label="App ID" required />
			<TextInput source="appOwnerId" label="App Owner ID" required />
			<NumberInput
				source="amountCentsUSD"
				label="Amount (cents USD)"
				required
			/>
			<TextInput
				source="destinationStripeAccountId"
				label="Destination Stripe Account ID"
				required
			/>
			<TextInput
				source="sourceStripeAccountId"
				label="Source Stripe Account ID"
				required
			/>
			<SelectInput
				source="status"
				required
				choices={[
					{ id: "queued", name: "Queued" },
					{ id: "processing", name: "Processing" },
					{ id: "transfer_created", name: "Transfer Created" },
					{ id: "paid", name: "Paid" },
					{ id: "failed", name: "Failed" },
					{ id: "reversed", name: "Reversed" },
					{ id: "needs_attention", name: "Needs Attention" },
				]}
			/>
		</SimpleForm>
	</Create>
);
